import { Stack, Typography } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CheckoutDocumentForm, { UpdateCoParameter } from 'src/app/pages/accounting/documents/checkout-document/checkout-document-form'
import { ReservationBillDocumentF } from '../../../types/reservation-detail.types'
import BillingGrid from './billing-grid/billing-grid'
import { HiCIcon } from 'src/app/components/icons/icon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons'
import DocumentReportViewer from 'src/app/components/report-viewer/documnent/document-report-viewer'

export type BillingProps = {
  propertyId: string
  documents: ReservationBillDocumentF[]
  readOnly: boolean
}

export default function Billing(props: BillingProps) {
  const { documents, propertyId, readOnly } = props
  const { t } = useTranslation()
  const [printDocumentId, setPrintDocumentId] = useState<string | null>(null)
  const [checkoutDocumentFormParams, setCheckoutDocumentFormParams] = useState<UpdateCoParameter | null>(null)
  return (
    <>
      <Stack direction="column" spacing={2} pt={4}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <HiCIcon>
            <FontAwesomeIcon icon={faFileInvoice} fontSize="1.25rem" />
          </HiCIcon>
          <Typography variant="titleSmall">{t('pms.booking.reservation.billing.title')}</Typography>
        </Stack>
        <BillingGrid //
          documents={documents}
          onEditClick={(documentId) => setCheckoutDocumentFormParams({ documentId })}
          readOnly={readOnly}
        />
      </Stack>
      {checkoutDocumentFormParams !== null && (
        <CheckoutDocumentForm //
          propertyId={propertyId}
          open={checkoutDocumentFormParams != null}
          onClose={() => setCheckoutDocumentFormParams(null)}
          onSuccess={({ documentId }) => {
            setCheckoutDocumentFormParams(null)
            setPrintDocumentId(documentId)
          }}
          onCreditNoteSuccess={() => setCheckoutDocumentFormParams(null)}
          refetchQueries={['ReservationDetail']}
          {...checkoutDocumentFormParams}
        />
      )}
      {printDocumentId && (
        <DocumentReportViewer
          open={printDocumentId !== null}
          setClose={() => {
            setPrintDocumentId(null)
          }}
          documentId={printDocumentId}
          propertyId={propertyId}
        />
      )}
    </>
  )
}
